import { createTheme } from '@mui/material/styles';

// Colores de la marca CV Printing
export const colors = {
  primary: '#a0588e',
  secondary: '#ffffff',
  text: {
    primary: '#000000',
    secondary: '#666666',
  },
  background: {
    default: '#f5f5f5',
    paper: '#ffffff',
  },
  border: '#e0e0e0',
};

// Tipografías
export const fonts = {
  primary: 'Poppins, sans-serif',
  secondary: 'Raleway, sans-serif',
  tertiary: 'Quicksand, sans-serif',
};

// Tema principal de la aplicación
export const theme = createTheme({
  typography: {
    fontFamily: `${fonts.primary}, ${fonts.secondary}, ${fonts.tertiary}`,
    h1: {
      fontFamily: fonts.primary,
      fontWeight: 700,
    },
    h2: {
      fontFamily: fonts.primary,
      fontWeight: 600,
    },
    h3: {
      fontFamily: fonts.primary,
      fontWeight: 600,
    },
    h4: {
      fontFamily: fonts.primary,
      fontWeight: 600,
    },
    h5: {
      fontFamily: fonts.primary,
      fontWeight: 600,
    },
    h6: {
      fontFamily: fonts.primary,
      fontWeight: 600,
    },
    body1: {
      fontFamily: fonts.primary,
    },
    body2: {
      fontFamily: fonts.primary,
    },
    button: {
      fontFamily: fonts.primary,
      fontWeight: 600,
    },
  },
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
    },
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
  },
}); 